module.exports = __webpack_public_path__ + "img/6-2.86f499d7.svg";